/**
 * 휴가 사용 단위 라벨 변환 공통 유틸
 *
 * SSoT: leaveRequests.unit / approvalRequests.requestData.unit
 * 타입: LeaveUnit = 'fullDay' | 'halfDay' | 'morningHalf' | 'afternoonHalf' | 'hourly'
 */

import { LeaveUnit } from '../types/leaveType';

const LEAVE_UNIT_LABEL_MAP: Record<LeaveUnit, string> = {
  fullDay: '전일',
  halfDay: '반차',
  morningHalf: '오전반차',
  afternoonHalf: '오후반차',
  hourly: '시간단위',
};

/**
 * LeaveUnit 코드를 한글 라벨로 변환
 * @param unit LeaveUnit 값 (없으면 '-' 반환)
 */
export function getLeaveUnitLabel(unit: LeaveUnit | string | undefined | null): string {
  if (!unit) return '-';
  return LEAVE_UNIT_LABEL_MAP[unit as LeaveUnit] || '-';
}
